import React from 'react';
import './MarqueeFooter.css';

function MarqueeFooter() {
    return (
        <footer className="marquee-footer">
            <div className="marquee-text">
                This is a scrolling footer message!
            </div>
        </footer>
    );
}

export default MarqueeFooter;
